/**
 * Created by Konstantino on 29/9/16.
 */
'use strict';

angular.module('meanApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('howtouse', {
        url: '/howtouse/:clientId',
        params: {
          clientId: {
            value: null,
            squash: false
          }
        },
        templateUrl: 'app/howtouse/howtouse.html',
        controller: 'howtouse-controller',
        authenticate: ['user','admin']
      });
  });
